import clsx from 'clsx'
import type { ReactNode } from 'react'

// Latin/numeric-only mono tags & kickers (DESIGN.md §3 — uppercase/tracking is
// quarantined to mono so it never lands on Vietnamese diacritics).
export function MonoTag({ children, live = false, className }: { children: ReactNode; live?: boolean; className?: string }) {
  return (
    <span className={clsx('monotag', className)}>
      {live && <span className="live-dot" aria-hidden />}
      <span className="tag">{children}</span>
    </span>
  )
}

// Note: no .tag here — kickers may carry Vietnamese, so we keep mono + light
// tracking but never text-transform/heavy letter-spacing (DESIGN.md §3).
export function MonoKicker({ children, className }: { children: ReactNode; className?: string }) {
  return <span className={clsx('mono-kicker', className)}>{children}</span>
}
